import React from "react";
import styles from "./Title.module.css";

const Title = ({ title, children }) => {
  return (
    <div className={` container-main `}>
      {children ? (
        <h1 className={styles.title}>
          {children}
          {/* <img src={img} alt="icon-title" width="40" height="40" /> */}
          {title}
        </h1>
      ) : (
        <h1 className={styles.title}>{title}</h1>
      )}
    </div>
  );
};

export default Title;
